<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_1"></a><a id="page_2"></a><a id="page_3"></a>The Book of the Beast</h1>
<p class="subtitle">The Orphan, The Captive, and The Beast</p>
<p class="author">Robert Stallman</p>
<div class="author">
<img alt="Images" src="Common/images/logo.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?2b852826